import {useState} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { SimpleSearch } from '../../../../../reduxToolkit/Search/SearchApi';
import {getViewTypeByName} from '../../../../../enums/ViewType';
import TableFunction from '../../../../../components/table/TableFunction';
import routes from '../../../../../Routes/routes';
import { useNavigate } from 'react-router-dom';
import { permissionObj } from '../../../../../Helpers/permission';
import { UpdateIconsOptions } from '../../../../../components/buttons/IconButtons';
import DropDownMenuProfile from './../../../../../components/DropDown/DropDownMenuProfile';
import DropDownMenuItem from '../../../../../components/DropDown/DropDownMenuItem';
import {LEFT_FIRST_COLUMN_WITH_CHECKBOX, SEARCH_MODEL} from '../../../../../components/table/Model/TableModel';
import DishListDetails from "../SubComponents/DishListDetails";
/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack
 * @Email : kpozos@ibl.mx
 *
 */
const DishesTableApp = ({
    view,
    setBodyForExport,
    modified,
    setModified,
    selectedList,
    setSelectedList,
    setIsAllChecked,
    option
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const dispatch = useDispatch();
    // State variables for UI and logic
    const [searchResults, setSearchResults] = useState([]);
    const [searchElement, setSearchElement] = useState("");
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const viewType = getViewTypeByName(view);


    const columns = [
        { field: "name", label: "name", fixed:true, left: LEFT_FIRST_COLUMN_WITH_CHECKBOX },
        { field: "code", label: "code_item" },
    ];

    // Render dropdown menu for actions per row
    const renderOptionsMenu = (item, index) => {
        return (
            <>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle} menuId={`menu-${item.id}`}>
                    {(DEV || permission?.includes(permissionObj?.WEB_FOODIE_ITEM_UPDATE)) && (
                        <DropDownMenuItem
                            index={index}
                            handleClose={handleClose}
                            name={t('update')}
                            icon={<UpdateIconsOptions />}
                            click={() => {
                                navigate(`${routes.foodieDish.update}${item.id}`);
                            }}
                        />
                    )}
                </DropDownMenuProfile>
            </>
        );
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({
            page: page,
            size: rowsPerPage,
            model: option,
            key: searchElement,
            viewType: viewType,
        });
        setBodyForExport(body);
        dispatch(SimpleSearch({ body })).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    setSearchResults(data);
                }
            },
        );
    }

    //pagination for list view
    const {
        handleCheckboxChange,
        handleDeleteAll,
        openMenu,
        handleMenuToggle,
        handleClose,
        pagination,
        rowsPerPage,
    } = TableFunction({
        selectedList,
        setSelectedList,
        data: searchResults,
        view,
        labelRowsPerPage: 'meals_per_page',
        setIsAllChecked,
        fixedPagination: false, // Disable fixed pagination
        hasContainer: true, // Enable container for the table
        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    const handleRowExpand = (row) => {};
    const renderExpandedRow = (row) => <DishListDetails id={row.id} DEV={DEV} item={row} />;

    return {
        t,
        columns,
        DEV,
        permission,
        rowsPerPage,
        searchResults,
        setSearchResults,
        searchElement,
        setSearchElement,
        search,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        handleDeleteAll,
        handleCheckboxChange,
        renderOptionsMenu,
        renderExpandedRow,
        handleRowExpand,
        pagination
    };
};

export default DishesTableApp;
